export const API_URL = process.env.REACT_APP_API_ENDPOINT;

export const LOGIN_USER_API = `${API_URL}/auth/login`;
export const LOGOUT_USER_API = `${API_URL}/auth/logout`;
export const AUTH_API = `${API_URL}/auth`;
export const ERRORS_API = `${API_URL}/error-logs`;
export const ERRORS_ORDERBY_API = `${API_URL}/error-logs/orderby`;
export const PRINTERS_ORDERBY_API = `${API_URL}/failed_ticket/orderby`;
export const FORTRESS_API = `${API_URL}/fortress`;
export const TICKETS_API = `${API_URL}/cards/tickets`;
export const CONCERT_API = `${API_URL}/concert`;
export const POLLING_API = `https://prod.eventimsport.com/polling`;